import StatusBadge from "../components/StatusBadge";

function LeagueEditPage({
  title = "League Setup",
  description = "Create or edit a competition on its own page instead of burying the form inside the overview desk.",
  metricsNode = null,
  gateNode = null,
  message = "",
  error = "",
  tabsNode = null,
  mainNode = null,
  railNode = null,
  selectedLeague = null,
}) {
  return (
    <section className="appRoutePage leagueEditRoutePage">
      <div className="routePageHeader leaguePageHeader">
        <div className="leaguePageHero">
          <div className="leaguePageHeroMark" aria-hidden="true">{"\u2699"}</div>
          <div className="leaguePageHeroCopy">
            <span className="leaguePageEyebrow">{selectedLeague ? "League Editor" : "Create Competition"}</span>
            <h1>{selectedLeague?.name || title}</h1>
            <p>{selectedLeague ? "Adjust format, registration settings, timing, and published rules on a dedicated page." : description}</p>
            <div className="leaguePageHeroMeta">
              {selectedLeague ? <StatusBadge status={selectedLeague.status} /> : null}
              {selectedLeague?.season_label ? <span>{selectedLeague.season_label}</span> : null}
            </div>
          </div>
        </div>
      </div>
      {metricsNode}
      {gateNode}
      {message ? <p className="successMessage">{message}</p> : null}
      {error ? <p className="errorMessage">{error}</p> : null}
      {tabsNode}
      <div className="leagueEditRouteShell leagueEditSplit">
        <div className="leagueEditPrimary">{mainNode}</div>
        <aside className="leagueEditAside">{railNode}</aside>
      </div>
    </section>
  );
}

export default LeagueEditPage;
